/** MSW: GET /eol/criteria/:id — View Criteria dialog (crossdock / shared EOL criteria shape). */
export const mockEolCriteriaDetailsApiResponse = {
  success: true,
  message: "Retrieved criteria details for criteria_id: 72",
  errorCode: null,
  item: {
    criteria: {
      groups: [
        {
          sequences: [
            {
              startTableName: "CLIENT",
              endTableName: "ACCESSORIAL",
              startFieldName: "ADDRESS",
              endFieldName: "ACCESSORIAL_CODE",
              startLookup: "COUNTRY",
              endLookup: "ACCESSORIAL_CODE",
              startLogic: "between",
              endLogic: "!=",
              logicValue: "like",
              startMin: "CA, OR, WA",
              startMax: "CA, OR, WA",
              endMin: "CA, OR, WA",
              endMax: "CA, OR, WA",
              reverseRange: false,
            },
          ],
        },
      ],
      betweenGroupLogic: [],
    },
  },
};
